export const TOGGLE_UNITS_SYSTEM = 'toggleUnitsSystem';
export const UPDATE_ACTIVE_WEATHER = 'updateActiveWeather';
export const UPDATE_COLOR_ACCENT = 'updateColorAccent';
export const UPDATE_IS_LOADING = 'updateIsLoading';
export const TOGGLE_DEV_INFO = 'toggleIsDevInfoShown';